import { transformRoute, type MenuDataItem } from '@umijs/route-utils';

export interface Route extends MenuDataItem {
  routes?: Route[];
}

export const getMenuData = (
  routes: Readonly<Route[]>,
  menuDataRender?: (menuData: MenuDataItem[]) => MenuDataItem[],
): {
  menuData: MenuDataItem[];
} => {
  const { menuData } = transformRoute(routes as Route[], false, undefined, true);
  if (!menuDataRender) return { menuData };
  return getMenuData(menuDataRender(menuData), undefined);
};
